module.exports = __webpack_public_path__ + "img/CRC2_Plasma.89ba9b68.png";